import { render, staticRenderFns } from "./EstimageMessageNew.vue?vue&type=template&id=b0ce10de"
import script from "./EstimageMessageNew.vue?vue&type=script&lang=js"
export * from "./EstimageMessageNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports